import { Navigate } from "react-router-dom";
import { hasPermission } from "../utils/auth";

export default function ProtectedRoute({
  children,
  allowedRoles = [],
  requiredPermission = null,
}) {
  const token = localStorage.getItem("token");
  const roles = JSON.parse(localStorage.getItem("roles") || "[]");

  // No login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // // Admin full access always
  // if (roles.includes("admin")) {
  //   if (requiredPermission && !hasPermission(requiredPermission)) {
  //     return <Navigate to="/unauthorized" replace />;
  //   }

  //   return children;
  // }

  // // Role check
  // if (
  //   allowedRoles.length > 0 &&
  //   !allowedRoles.some((role) => roles.includes(role))
  // ) {
  //   return <Navigate to="/unauthorized" replace />;
  // }

  // // Permission check
  // if (requiredPermission && !hasPermission(requiredPermission)) {
  //   return <Navigate to="/unauthorized" replace />;
  // }

  return children;
}